import React, { useEffect, useRef } from 'react';
import styles from './Me.module.css';
import esther from "../../images/אסתר מטטוב תמונה ראשית.png";

const AboutMe = () => {
  const containerRef = useRef(null);

  const handleButtonClick = () => {
    const phoneNumber = "+972535277277";
    const message = "היי אסתר, הגעתי מהדף שלך ואני רוצה לשמוע עוד על הקורסים שלך!";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  useEffect(() => {
    if (containerRef.current) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
            }
          });
        },
        { threshold: 0.2 }
      );

      const revealElements = containerRef.current.querySelectorAll(`.${styles.revealItem}`);
      revealElements.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 1s ease, transform 1s ease';
        observer.observe(el);
      });

      return () => observer.disconnect();
    }
  }, []);

  return (
    <section ref={containerRef} className={styles.section} id="מי-אני">
      <div className={styles.container}>
        <div className={`${styles.imageWrapper} ${styles.revealItem}`}>
          <img src={esther} alt="אסתר מטטוב" className={styles.image} />
        </div>

        <div className={`${styles.content} ${styles.revealItem}`}>
          <h2 className={styles.mainTitle}>נעים להכיר, אסתר מטטוב</h2>

          <div className={styles.textBlock}>
            <p className={styles.paragraph}>
              אני אסתר, מורה, מדריכה, ואישה שאוהבת להרים אחרות.
              נולדתי עם אהבה ליופי, דיוק ויצירתיות, אבל רק כשהכרתי את עולם הציפורניים הבנתי שזה הייעוד שלי.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              הדרך שלי לא הייתה קלה. למדתי, חקרתי, טעיתי, ושיפרתי, עד שיצרתי שיטה מדויקת שמביאה תוצאות מושלמות גם למי שמעולם לא נגעה במכחול.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אצלי אין פס ייצור של תלמידות. יש יחס אישי, קבוצות קטנות, ליווי אמיתי, והמון לב.
              אני מאמינה שמי שמלמדת מהלב, נוגעת בלב.
              ומי שבאה עם רצון אמיתי – תצא עם מקצוע לחיים.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אין דבר שמרגש אותי יותר מלראות תלמידות שלי פורחות.
              כבר בזמן הקורס הן יוצרות עבודות ברמה גבוהה,
              ובסיומו יוצאות לדרך עצמאית עם ביטחון ויכולות אמיתיות.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.finalText}>
              אם את חולמת להתחיל,
              ורוצה מישהי שתאמין בך כמו שאת – אני כאן.
              הלב שלי פתוח, והדרך שלך מתחילה בצעד אחד קטן.
            </p>
          </div>

          <button className={styles.ctaButton} onClick={handleButtonClick}>
            <span className={styles.buttonIcon}>💅</span>
            אני רוצה ללמוד לבנות ציפורניים כמו מקצוענית
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
